<script lang="ts" setup>
import type { ContentProductPackage } from '~/models/Content/ContentProductPackage'
import type { ContentProductHeader } from '~/models/Content/ContentProductHeader'
import type { ContentFolder } from '~/models/Content/ContentFolder'
import { useI18n } from 'vue-i18n'
import { computed, toRef } from 'vue'
import { useUrlBuilder } from '~/composables/useUrlBuilder'
import useTeacherGuide from '~/composables/useTeacherGuide'
import Button from '~/components/ui/Button.vue'

const { selectedHeader } = defineProps<{
  selectedHeader: ContentProductHeader | ContentProductPackage | ContentFolder
}>()

const { t } = useI18n()
const { buildResourceUrl } = useUrlBuilder()

const { teacherArticle } = useTeacherGuide({
  contentId: Number(selectedHeader.teacherGuide?.destinationContentId),
  enabled: toRef(() => Number(selectedHeader.teacherGuide?.destinationContentId) > 0),
  withContent: false,
})

const teacherArticleLink = computed(() => teacherArticle.value
  ? buildResourceUrl(teacherArticle.value)
  : '')
</script>

<template>
  <Button
    v-if="selectedHeader && teacherArticleLink"
    :to="teacherArticleLink"
    color="teacher"
    size="lg"
    v-bind="$attrs"
  >
    {{ t('filters.forTeacher') }}
  </Button>
</template>
